import React from 'react';
import '../App.css';
const LoadingSpinner = () => {
  return (
    <div className="spinner-container">
      <div className="loading-spinner"></div>
    </div>
  );
};
export default LoadingSpinner;
